"use strict";
/*
 * Created on 01 02 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractConstraintConverter_1 = require("./AbstractConstraintConverter");
/**
 * @author Jaroslav Sevcik
 */


var WeekDayRestrictionConverter =
/*#__PURE__*/
function (_AbstractConstraintCo) {
  _inherits(WeekDayRestrictionConverter, _AbstractConstraintCo);

  function WeekDayRestrictionConverter() {
    _classCallCheck(this, WeekDayRestrictionConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WeekDayRestrictionConverter).apply(this, arguments));
  }

  return WeekDayRestrictionConverter;
}(AbstractConstraintConverter_1.AbstractConstraintConverter);

exports.WeekDayRestrictionConverter = WeekDayRestrictionConverter;